const KB = 1024;
const MB = KB * 1024;

/** Human-readable byte size for advisor-facing file rows. Consistent output
 *  across `AdditionalDocumentsStep` (per-file row), `PdfGenerationStep`
 *  (per-file row), and `ApplicationReviewStep` (uploaded-documents recap)
 *  so the same file reports the same size everywhere in the flow. */
export function formatFileSize(bytes: number): string {
  if (bytes >= MB) return `${(bytes / MB).toFixed(1)} MB`;
  if (bytes >= KB) return `${(bytes / KB).toFixed(0)} KB`;
  return `${bytes} B`;
}
